import './music.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import RibbonsUtil from '../../utils/RibbonsUtil';
// import RibbonGrid from '../../components/RibbonGridClone';
import RibbonGrid from '../../components/RibbonGridNew';
import Spinner from './../../components/Spinner';
import ContextMenu from '../../components/ContextMenu';
import MusicActions from '../../components/MusicActions';
import MusicUtils from '../../actions/musica/music-actions';
import { fetchLoginDynamic } from '../../reducers/user';
import { bindActionCreators } from 'redux';
import { setResumeData } from '../../actions/resume';
import {
    setFirstPlaylistFree,
    doPGMPlaylist,
    doPGMAlbum,
    doPGMSongs,
    doPGMRadio
} from '../../actions/musica/player-shared-action-creators';
import { addToContextMenu } from '../../actions/musica/context-menu-actions';
import { setMetricsEvent } from '../../actions/metrics';
import { playFullMedia } from '../../actions/playmedia';
import Device from '../../devices/device';
import * as api from '../../requests/loader';
import PlayerTracksUtil from '../../utils/PlayerTracksUtils';
import PLAYERTRACK_TYPE from '../Music/playerTracksType';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Utils from '../../utils/Utils';
import store from '../../store';

class Music extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ribbons: [],
            reloadGrid: true,
            visibleNumber: 6,
            isFetching: false,
            currentContent: {},
            pgm: null,
            topSongs: [],
        };

        this.onFocusCardHandler = this.onFocusCardHandler.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.keys = Device.getDevice().getKeys();
        this.handlePlay = this.handlePlay.bind(this);
        this.ribbonsCategories = RibbonsUtil.getRibbonsCategories(props.code, props.nodes);
        this.loginRegisterMusicEnabled = Utils.getApaMetadataKey("loginRegister_music_enabled", '{"enable": false}', "enable");
    }

    // EN LUGAR DE HACER EL FETCH DEL USUARIO DE CLAROMUSICA SE REDIRECCIONA AL LOGIN DE CLAROMUSICA
    componentWillMount() {
        if(this.loginRegisterMusicEnabled && !DeviceStorage.getItem('userCM')) {
            const { history } = this.props;
            history.push('/loginCM');
        } else if (this.loginRegisterMusicEnabled && DeviceStorage.getItem('userCM')) {
            this.props.fetchLoginDynamic(null);
        } else if (!this.loginRegisterMusicEnabled) {
            this.props.fetchLoginDynamic(this.props.user.email);
        }
    }

    componentDidMount() {
        if (this.props.user.musicUser) {
            this.getCarousels(this.props.user.musicUser);
        }
        document.addEventListener('keydown', this.handleKeyPress, true);
        // Cookie.clear();
    }
    componentWillUpdate() {
        if (!this.state.isFetching) {
            setTimeout(() => window.SpatialNavigation.focus('.scroller-container .focusable'), 0);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress, true);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user.musicUser !== this.props.user.musicUser) {
            this.getCarousels(nextProps.user.musicUser);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps !== this.props || nextState.pgm !== this.state.pgm;
    }

    getCarousels(user) {
        this.setState({ isFetching: true });
        let musicRb = new RibbonsUtil();
        musicRb
            .getMusicRibbonsFromApi('ribbons', user, {
                method: 'GET',
                payload: { filter: 'general' }
            })
            .then(resp => {
                this.setState({
                    ribbons: resp.ribbons,
                    isFetching: false,
                    topSongs: resp.topSongs
                });
                this.props.setFirstPlaylistFree(resp.playlistFreeId);
            })
            .catch(err => {
                console.log('getCarousels fail ribbons: ' + err);
            });
    }

    onFocusCardHandler(data) {
        const elements = document.getElementsByClassName('focused');
        if (elements.length > 0) elements[0].classList.remove('focused');

        const selEl = document.getElementById(`card-${data.music_class}-${data.musicData.id}`);
        if (selEl) selEl.classList.add('focused');

        const itemData = this.metadataCarousels(data);
        this.setState({ currentContent: data });
        this.props.setResumeData(itemData);
    }

    metadataCarousels(data) {
        const type = data.type;
        switch (type) {
            case 'Album':
                return {
                    title: data.title,
                    year: data.artist,
                    rating: '',
                    category: data.record,
                    duration: data.year,
                    description: '',
                    isMusic: true,
                    overWrite: true
                };
            case 'Playlist':
                return {
                    title: data.title,
                    year: data.followers,
                    rating: '',
                    category: data.tracks,
                    duration: data.duration,
                    description: '',
                    overWrite: true
                };
            case 'Radio':
                return {
                    title: data.title,
                    year: data.band,
                    rating: '',
                    category: data.dial,
                    duration: '',
                    description: '',
                    overWrite: true
                };
            default:
                return {
                    title: data.title || data.name || data.type,
                    year: data.type === '',
                    rating: '',
                    category: '',
                    duration: '',
                    description: data.crest,
                    overWrite: true
                };
        }
    }

    handleKeyPress(e) {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'BACK':
                if(DeviceStorage.getItem('userCM')) {
                     const state = store.getState();
                     if(state.player.playerstate !== 'PLAYING'){
                        e.stopPropagation();
                        this.props.history.goBack();
                     }
                }
                break;
            case 'OK': //only for play songs and radios
                if (
                    this.state.currentContent.type === 'Song' ||
                    this.state.currentContent.type === 'Radio'
                ) {
                    let button = document.activeElement;
                    if(button.classList.contains("link") && button.classList.contains("focusable")){
                        this.handlePlay();
                    }
                }
                break;
            default:
                break;
        }
    }

    sendToPlay = (pgm, isLive = false) => {
        if (pgm) {
            this.props.playFullMedia({
                playerstate: 'PLAYING',
                source: {
                    audiosource: pgm.media.video_url
                },
                ispreview: false,
                islive: isLive,
                ispip: false
            });
        }
    };

    handlePlay(index) {
        const musicContent = this.state.currentContent.musicData;
        const playerTracks = new PlayerTracksUtil();
        if (this.state.currentContent.type === 'Playlist') {
            const params = {
                list_id: musicContent.id
            };
            api.getPlaylistDetail(params)
                .then(response => {
                    const { data: { tracks = [] } = {} } = response;
                    playerTracks
                        .getPlayerTracks(PLAYERTRACK_TYPE.PLAYLIST, params.list_id)
                        .then(resp => {
                            const pgm_musica = this.props.doPGMPlaylist(0, {
                                playlistDetail: {
                                    tracks,
                                    playerTracks: resp
                                }
                            });
                            this.sendToPlay(pgm_musica);
                        })
                        .catch(err => {
                            console.log('[MUSIC]-err', err);
                        });
                })
                .catch(err => console.log(err));
        } else if (this.state.currentContent.type === 'Album') {
            const params = {
                album_id: musicContent.id
            };
            api.getAlbumDetail(params)
                .then(response => {
                    const { data: { volumes = [] } = {} } = response;
                    playerTracks
                        .getPlayerTracks(PLAYERTRACK_TYPE.ALBUM, params.album_id)
                        .then(resp => {
                            let pgm_musica = this.props.doPGMAlbum(0, {
                                volumes,
                                playerTracks: resp
                            });
                            this.sendToPlay(pgm_musica);
                        })
                        .catch(err => {
                            console.log('[MUSIC]-err', err);
                        });
                })
                .catch(err => console.log(err));
        } else if (this.state.currentContent.type === 'Song') {
            const tracks = this.state.topSongs.elements.map(track => {
                return {
                    ...track,
                    url: track.url.replace('FAKE_TOKEN', this.props.user.musicUser.token)
                };
            });
            const song = this.state.currentContent.musicData;
            index = song.trackNumber > 0 ? song.trackNumber - 1 : 0;
            const musicRb = new RibbonsUtil();
            musicRb.getIsFavoriteFromApi("song", this.props.user, { countryCode: this.props.user.countryCode, contentId: song.id }).then((resp) =>{
                tracks[index].isFavorite = resp.isFavorite;
                let pgm_musica = this.props.doPGMSongs(index, { tracks });
                this.sendToPlay(pgm_musica);
            });
        } else if (this.state.currentContent.type === 'Radio') {
            const radio = this.state.currentContent.musicData;
            const musicRb = new RibbonsUtil();
            musicRb.getIsFavoriteFromApi("radio", this.props.user, { countryCode: this.props.user.countryCode, contentId: radio.id }).then((resp) =>{
                radio.isFavorite = resp.isFavorite;
                let pgm_musica = this.props.doPGMRadio(radio.url, radio);
                this.sendToPlay(pgm_musica, true);
            });
        }
    }

    render() {

        return (
            <div className="music-container">
                {this.state.isFetching ? <Spinner className="spinner-music" /> : ''}
                {this.state.ribbons.length > 0 ? (
                    <RibbonGrid
                        ribbons={this.state.ribbons}
                        onFocusHandler={this.onFocusCardHandler}
                        reload={this.state.reloadGrid}
                        ribbonsTypeMenu="music"
                        visibleNumber={this.state.visibleNumber}
                        setMetricsEvent={this.props.setMetricsEvent}
                        ribbonsCategories={this.ribbonsCategories}
                        isMusic={true}
                    />
                ) : (
                    ''
                )}
                <ContextMenu
                    ref={instance => {
                        this.contextMenu = instance;
                    }}
                />
                <MusicActions
                    actionType="musicHome"
                    buttonData={this.state.currentContent}
                    blueAction={this.handlePlay}
                    yellowAction={() => {}}
                    greenAction={this.toggleMore}
                    isHidden={true}
                    device={MusicUtils.getMusicDevice()}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({ user: state.user, playerMusica: state.playermusica });
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchLoginDynamic,
            setResumeData,
            setFirstPlaylistFree,
            doPGMPlaylist,
            doPGMAlbum,
            doPGMSongs,
            doPGMRadio,
            addToContextMenu,
            setMetricsEvent,
            playFullMedia
        },
        dispatch
    );
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Music));



// WEBPACK FOOTER //
// ./src/containers/Music/index.jsx